import Link from 'next/link';
import Text from '@deprecated-ui/common/Text';
import Button from '@deprecated-ui/common/Button';
import { useEffect, useState } from 'react';
import Image from 'global/Image';
import { Input, ItemContainer, FormContainer } from '../styled';
import { affiliateNavigationEvents } from '../analytics';

interface Props {
  error: boolean;
  onSubmit: React.FormEventHandler<HTMLFormElement>;
}

function ReferralForm({ error, onSubmit }: Props) {
  const [code, setCode] = useState('');
  const onChangeCode = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCode(event.target.value);
  };

  useEffect(() => {
    affiliateNavigationEvents.externalCommunityViewed();
  }, []);

  return (
    <form onSubmit={onSubmit} style={{ width: '100%' }}>
      {/* @ts-expect-error */}
      <FormContainer align="flex-start" m="0">
        <Image
          alt="logo"
          src="images/community/hero.svg"
          width={180}
          height={140}
        />
        <Text
          // @ts-expect-error
          mt="24px"
          size="18px"
          height="24.3px"
          family="bold"
          align="center"
          mb="8px"
        >
          Aktivasi Kode Komunitas
        </Text>
        {/* @ts-expect-error */}
        <Text mb="24px" size="14px" height="21px" align="center">
          Masukkan kode untuk mulai investasi bersama komunitas kamu.
        </Text>
        <ItemContainer justify="flex-start" align="flex-start">
          <Input
            id="code"
            name="code"
            value={code}
            required
            // @ts-expect-error
            status={error ? 'error' : ''}
            onChange={onChangeCode}
            placeholder="Masukkan Kode Komunitas"
          />
          {error ? (
            <Text
              size="12px"
              height="16px"
              family="regular"
              // @ts-expect-error
              mt="5px"
              color="#EE4A49"
            >
              <Image
                alt="logo"
                src="images/community/warning.svg"
                width={16}
                height={16}
                style={{
                  marginTop: -2,
                }}
              />{' '}
              Kode komunitas tidak ditemukan
            </Text>
          ) : null}
        </ItemContainer>
        <ItemContainer justify="center" align="center">
          <Text
            size="12px"
            height="16px"
            family="regular"
            // @ts-expect-error
            mb="20px"
            mt="40px"
            align="center"
          >
            Dengan menggunakan kode komunitas, saya mengerti dan menyetujui{' '}
            <Link href="/community-rules">Syarat & Ketentuan</Link> yang
            berlaku.
          </Text>
          <Button
            htmlType="submit"
            type="primary"
            height="36px"
            disabled={code.length === 0}
            width="100%"
          >
            <Text family="bold" color="white">
              Lanjut
            </Text>
          </Button>
        </ItemContainer>
      </FormContainer>
    </form>
  );
}

export default ReferralForm;
